<template>
<div>
  <mdl-snackbar display-on="flash"></mdl-snackbar>
  <router-view></router-view>
</div>
</template>
<script>
import { MdlSnackbar } from 'vue-mdl'

export default {
  components: {
    MdlSnackbar
  }
}
</script>
<style lang="less">
@import './material.min.css';

.mdl-list__item {
  font-size: 20px;
}

.mdl-list__item--three-line .mdl-list__item-text-body {
  font-size: 16px;
}

.bigger-font input {
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// App.vue?15400b50